import React, { Component } from 'react';
import Keycloak from 'keycloak-js';
import { withStyles } from '@material-ui/core/styles';
import { getQueryValue } from 'utils/';
import api from 'api/';
import userInfo from 'utils/userInfo';
import swal from 'sweetalert';
import links from 'utils/links';

const styles = theme => ({
  loginWrapper: {
    minHeight: '100%',
    minWidth: '100%',
    zIndex: '9999',//'100001',
    backgroundColor: 'white',
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '0',
    [theme.breakpoints.only('lg')]: {
      minHeight: '100%',
      minWidth: '100%',
      zIndex: '9999',//'100001',
      backgroundColor: 'white',
      color: theme.palette.secondary.main,
      position: 'absolute',
      top: '0',
      left: '0px',
    },
  },
  loader: {
    width: '100px',
    height: '100px',
  },
  centered: {
    position: 'fixed',
    top: '40%',
    left: '40%',
  },
  centerText: {
    textAlign: 'center',
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { keycloak: null, authenticated: false };
  }
  validateLogin() {
    const keycloak = Keycloak('/keycloak.json');
    let self = this;
    let userInfo = {};
    keycloak
      .init({ onLoad: 'login-required' })
      .success(function (authenticated) {
        if (keycloak.tokenParsed.email) {
          (async () => {
            userInfo = await api.getUserByEmail(keycloak.tokenParsed.email);
            if (!userInfo.data) {
              userInfo = await api.createUser([{
                "contactDetails": {
                  "email": keycloak.tokenParsed.email
                },
                "displayName": keycloak.tokenParsed.name,
                "name": keycloak.tokenParsed.name,
                "userName": keycloak.tokenParsed.email,
              }]);
            }
            let tsUserInfo = {
              ...keycloak.tokenParsed,
              token: keycloak.token,
              refreshToken: keycloak.refreshToken,
              userInfo: userInfo.data,
            };
            localStorage.setItem('tsUserInfo', JSON.stringify(tsUserInfo));
            self.setState({ keycloak: keycloak, authenticated: authenticated });
          })();
        }
      })
      .error(function (e) {
        alert('failed to initialize, please contact administrator');
      });
  }
  componentDidMount() {
    this.validateLogin();
  }
  componentDidUpdate() {
    const isUserContributor = userInfo.doesUserHaveRole("contributor");
    const user = userInfo.getUserProfile();
    if (this.state.authenticated) {
      let redirectUrl = getQueryValue('redirect');
      let self = this;
      if (isUserContributor && (!user.profilePic || !user.userProfile.hometown || !user.cuisinesOfExpertise)) {
        swal({
          title: "Looks like you haven't completed your profile!",
          text: "Would you mind filling in some details?\nPlease note : A completed profile is more likely to be Featured!",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "Skip for now!",
            continue: "Yes! Update My Profile",
          },
        })
          .then((value) => {
            switch (value) {
              case "cancel":
                self.props.history.push(redirectUrl ? redirectUrl : '/');
                break;
              case "continue":
                self.props.history.push(links.staticLink("my-profile"));
                break;
              default:
                self.props.history.push(redirectUrl ? redirectUrl : '/');
            }
          });
      }
      else {
        this.props.history.push(redirectUrl ? redirectUrl : '/');
      }
    }
  }
  render() {
    const { classes } = this.props;
    if (this.state.keycloak) {
      if (!this.state.authenticated) {
        return (
          <div className={classes.loginWrapper}>
            <div className={classes.centered}>Unable to authenticate!</div>
          </div>
        );
      }
    }
    return (
      <div className={classes.loginWrapper}>
        <div className={classes.centered}>
          <img className={classes.loader} src="/img/login-spinner.gif" alt="" />
          <h4 className={classes.centerText}>Logging in ...</h4>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Login);
